module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "my-1 row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('common.bids')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('b-pagination-nav', {
    staticClass: "pull-right",
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.bids.meta.totalPages,
      "value": _vm.bids.meta.currentPage,
      "use-router": ""
    }
  })], 1)]), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.bids.isFetching
    }
  }), _vm._v(" "), (!_vm.bids.isFetching) ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.bids.data,
      "fields": _vm.fields,
      "per-page": parseInt(_vm.bids.meta.perPage),
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "busy": _vm.bids.isFetching,
      "empty-text": _vm.$t('bid.listEmptyText'),
      "empty-filtered-text": _vm.$t('bid.listEmptyFilteredText')
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(created_at)",
      fn: function(row) {
        return [_vm._v("\n \t\t\t\t  " + _vm._s(_vm._f("smallDate")(row.item.created_at)) + "\n \t\t")]
      }
    }, {
      key: "cell(item)",
      fn: function(row) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'item',
              params: {
                itemId: row.item.item.id
              }
            }
          }
        }, [_c('strong', [_vm._v(_vm._s(row.item.item.seller.code) + "-" + _vm._s(row.item.item.number))]), _vm._v(" " + _vm._s(row.item.item.title) + "\n\t\t\t\t")])]
      }
    }, {
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-btn-group', {
          staticClass: "pull-right"
        }, [_c('b-btn', {
          attrs: {
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteModal(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-trash"
        })]), _vm._v(" "), _c('b-btn', {
          attrs: {
            "exact": "",
            "variant": "outline-primary",
            "to": {
              name: 'bidEdit',
              params: {
                bidId: row.item.id,
                itemId: row.item.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-edit"
        })])], 1)]
      }
    }], null, false, 2178660016)
  }) : _vm._e(), _vm._v(" "), _c('delete-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "delete-name": _vm.selectedDeleteItemName,
      "item": _vm.selectedDeleteItem,
      "isDeleting": _vm.isDeleting
    },
    on: {
      "confirm": _vm.deleteBid
    }
  }), _vm._v(" "), _c('b-pagination-nav', {
    staticClass: "pull-right",
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.bids.meta.totalPages,
      "value": _vm.bids.meta.currentPage,
      "use-router": ""
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "hidden": ""
    }
  }, [_vm._v("\n\t\tSort By: " + _vm._s(_vm.sortBy || 'n/a') + ", Direction: " + _vm._s(_vm.sortDesc ? 'descending' : 'ascending') + "\n\t")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e31769d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Bid/BidList.vue
// module id = 1344
// module chunks = 1